import { getInvoices } from '@app/ducks';
import { isEmpty } from '@app/utils/isEmpty';
import { Order, Payments } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CheckoutSuccessInvoiceCard } from './CheckoutSuccessInvoiceCard';
import { CheckoutSuccessPrepaymentCard } from './CheckoutSuccessPrepaymentCard';

interface Props {
  order: Order.Closed;
  payments: Payments.Payment[] | undefined;
}

export const CheckoutSuccessPayments = ({ order, payments = [] }: Props) => {
  const { t } = useTranslation(['payments']);
  const invoices = useSelector(getInvoices);

  if (isEmpty(payments) && isEmpty(invoices)) {
    return null;
  }

  return (
    <div className="box">
      <h3 className="mb-5 heading-3">{t('payments:payment_other')}</h3>
      <div className="flex w-full flex-col gap-5">
        {invoices.map(invoice => (
          <CheckoutSuccessInvoiceCard key={invoice.invoice} invoice={invoice} orderId={order.order} />
        ))}
        {payments.map(payment => (
          <CheckoutSuccessPrepaymentCard key={payment.payment} payment={payment} order={order} />
        ))}
      </div>
    </div>
  );
};
